import { Component, inject, Input } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router, Scroll } from '@angular/router';
import { filter, map } from 'rxjs/operators';

@Component({
  selector: 'app-yopa-logo',
  templateUrl: './yopa-logo.component.html',
  styleUrls: ['./yopa-logo.component.scss']
})
export class YopaLogoComponent {

  @Input() customClass: string;

  protected readonly route = inject(ActivatedRoute);
  protected readonly router = inject(Router);

  private readonly ASSOCIATES_ROUTE_GROUP = 'associates';

  protected readonly isAssociatesRoute$ = this.router.events
    .pipe(
      filter((event) => {
        const isNavigationEndEvent: boolean = event instanceof NavigationEnd;
        const isNavigationScrollEvent: boolean = event instanceof Scroll && event.routerEvent instanceof NavigationEnd;

        return isNavigationEndEvent || isNavigationScrollEvent;
      }),
      map(
        (event: NavigationEnd | Scroll) => event instanceof NavigationEnd
          ? event.url.includes(this.ASSOCIATES_ROUTE_GROUP)
          : event.routerEvent.url.includes(this.ASSOCIATES_ROUTE_GROUP)
      ),
    );
}
